import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=6c374e14&scoped=true&lang=pug&"
import script from "./TheFooter.vue?vue&type=script&lang=js&"
export * from "./TheFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=6c374e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c374e14",
  null
  
)

component.options.__file = "TheFooter.vue"
export default component.exports